import { isHttpNotFoundErrorResponse } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import { performGetRequest, performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';

export const LEAD_WITH_BOARDS_PROJECT_PROPERTY_KEY = 'isLeadWithBoardsEnabled';

type ProjectPropertyResponse = {
	value: boolean;
};

const getProjectPropertyUrl = (projectKey: string): string =>
	`/rest/api/3/project/${encodeURIComponent(projectKey)}/properties/${LEAD_WITH_BOARDS_PROJECT_PROPERTY_KEY}`;

export const getLeadWithBoardsProjectProperty = async (projectKey: string): Promise<boolean> => {
	try {
		const { value } = await performGetRequest<ProjectPropertyResponse>(
			getProjectPropertyUrl(projectKey),
		);
		return value;
	} catch (error: unknown) {
		const requestError = error instanceof Error ? error : new Error(String(error));
		if (!isHttpNotFoundErrorResponse(requestError)) {
			fireErrorAnalytics({
				error: requestError,
				meta: {
					id: 'jiraServicedeskLeadWithBoardsProjectPropertyResource',
					packageName: 'jiraRouterResourcesServiceDeskQueues',
					teamName: 'it-service-core-capabilities-team',
				},
				sendToPrivacyUnsafeSplunk: true,
			});
		}
		throw error;
	}
};

export const updateLeadWithBoardsProjectProperty = (
	projectKey: string,
	isLeadWithBoardsEnabled: boolean,
): Promise<void> =>
	performPutRequest(getProjectPropertyUrl(projectKey), {
		body: JSON.stringify(isLeadWithBoardsEnabled),
	}).catch((error: unknown) => {
		fireErrorAnalytics({
			error: error instanceof Error ? error : new Error(String(error)),
			meta: {
				id: 'updateLeadWithBoardsProjectPropertyError',
				packageName: 'jiraRouterResourcesServiceDeskQueues',
				teamName: 'it-service-core-capabilities-team',
			},
		});
		throw error;
	});
